import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  // urlBase: String = 'localhost:8080/api';
  // configUrl = '/index';
  // configUrlReferncia = '/buscaReferencia'
  //
  // constructor(private http: HttpClient) {
  //   console.log('configService');
  // }
  //
  // getConfig() {
  //   return this.http.get(this.urlBase + this.configUrl);
  // }

  // getReferencia() {
  //   return this.http.get(this.urlBase + this.configUrlReferncia);
  // }
}
